import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DirectoryHomeComponent} from "./directory-home/directory-home.component";


const routes: Routes = [
  {
    path: '',
    redirectTo: 'directory',
    pathMatch: 'full'
  },
  {
    path: 'directory',
    component: DirectoryHomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DirectoryRoutingModule { }
